var $254c7eb682749050$exports = {};
$254c7eb682749050$exports = {
    "Empty": `Prazno`
};


export {$254c7eb682749050$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
